import { KeyRoundIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import useMembers from '@/hooks/useMembers';

import { apiKeyTypeLabelMapper } from './helper';
import { ResourceTile } from '../../components/ResourceList/ResourceTile';
import {
  CreatorMeta,
  LastUsedMeta,
  ResourceTileMeta,
  ResourceTileStatus,
} from '../../components/ResourceList/ResourceTileParts';
import { Credential } from '../../types';

interface APIKeyItemProps {
  credential: Credential;
  isSelected: boolean;
  onOpen: (credential: Credential) => void;
}

export const APIKeyItem = ({ credential, isSelected, onOpen }: APIKeyItemProps) => {
  const { t } = useTranslation();
  const { getMember } = useMembers();
  const { name, type, created_by, last_used_at } = credential;
  const creator = created_by ? getMember(created_by) : undefined;

  return (
    <ResourceTile
      icon={<KeyRoundIcon aria-hidden="true" className="h-6 w-6 text-muted-foreground" />}
      title={name}
      status={<ResourceTileStatus label={apiKeyTypeLabelMapper(type, t)} flavour="neutral" />}
      meta={
        <ResourceTileMeta>
          {creator && <CreatorMeta member={creator} />}
          <LastUsedMeta lastUsedAt={last_used_at} />
        </ResourceTileMeta>
      }
      onOpen={() => onOpen(credential)}
      isSelected={isSelected}
    />
  );
};
